<!--
 * @Author: your nodeName
 * @Date: 2020-12-02 15:16:35
 * @LastEditTime: 2020-12-24 18:50:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /unicom_back_dev_20200628/src/views/applicationManagement/qualitySafety/resourceManage/qualitySubitem.vue
-->
<template>
  <div>
    <div class="flex_column_top">
      <div class="display_flex_center_row paddingleft_20_right_20">
        <div class="font_16_color_37474f">
          选择区域模板
        </div>
        <img src="../../../../assets/img/quality_detaillogo.png" class="quality_logo">
        <div class="font_14_999">
          设为当前模板后，手机端抓拍仅会按照当前模板所设置的区域显示
        </div>
      </div>
      <div class="div_spaceBetween paddingleft_20_right_20">
        <div class="display_flex_center_row">
          <el-select
            v-model="templateVlaue"
            class="currentInput"
            placeholder="请选择模版"
            style="margin-right: 20px"
            @change="templateVlaueChanged()"
          >
            <el-option
              v-for="item in templateArray"
              :key="item.modelId"
              :label="item.modelName"
              :value="item.modelId"
            />
          </el-select>
          <el-button
            type="primary"
            :disabled="templateVlaue ? false : true"
            @click="updateQualityDataRequest()"
          >
            设为当前模版
          </el-button>
          <el-button
            :disabled="templateVlaue ? false : true"
            type="text"
            @click="changeTemeplateMethod"
          >
            修改模版名称
          </el-button>
          <el-button
            :disabled="templateVlaue ? false : true"
            type="text"
            @click="deleteTemeplateMethod"
          >
            删除模版
          </el-button>
        </div>
        <el-button type="primary" @click="createEmptyTemplete()">
          创建空模版
        </el-button>
      </div>
      <div
        style="height: 10px; background: #f8f8f8; margin-top: 15px"
        class="bottom_boder_style"
      />
    </div>

    <div class="wrapper">
      <div class="total_left_content">
        <div class="top_space_between">
          <div class="flex_row_center">
            <el-button type="text" icon="el-icon-plus" @click="addAreaMethod()" />
            <el-button type="text" icon="el-icon-folder-add" @click="addFolderMethod()" />
          </div>
        </div>
        <div class="left_bottom_contain">
          <el-input
            v-model="searchKey"
            class="margin_bottom_10"
            placeholder="搜索区域"
            suffix-icon="el-icon-search"
            @input="inputChanged"
          />
          <el-tree
            ref="tree"
            class="companyTree"
            :data="areaArray"
            node-key="areaId"
            :filter-node-method="filterNode"
            default-expand-all
            @node-click="nodeClicked"
          >
            <div slot-scope="{ data }" class="display_flex_center_row space_between">
              <div class="display_flex_center_row">
                <img :src="getTreeIconImagePath(data)" class="tree_leftIcon">
                <div
                  class="treeTitle_normal"
                  :class="areaIsSelected(data) ? 'treeTitle_selected' : 'treeTitle_normal'"
                >
                  {{ getTreeText(data) }}
                </div>
              </div>
              <div v-if="data.level != 0" class="display_flex_center_row">
                <el-button type="text" icon="el-icon-edit-outline" @click.stop="editeMethod(data)" />
                <el-button type="text" icon="el-icon-delete" @click.stop="deleteMethod(data)" />
              </div>
            </div>
          </el-tree>
          <div style="height: 20px" />
        </div>
      </div>
      <div class="total_right_content left_border">
        <!-- <div class="top_space_between">
          <div class="flex_row_center">
            <div>{{ currentAreaName }}</div>
            <div class="fontsize_12_color">
              (双击编辑已绘制区域)
            </div>
            <el-input
              v-model="searchKeyword"
              placeholder="搜索地图位置"
              prefix-icon="el-icon-search"
              style="width: 200px; margin-left: 10px"
              @input="inputChangeAnother"
            />
          </div>
          <div class="flex_row_center">
            <el-button type="text" icon="el-icon-plus" @click="createPolygon()">
              添加区域
            </el-button>
            <el-button
              type="text"
              icon="el-icon-delete"
              @click="clearMapMethod()"
            >
              清空绘制区域
            </el-button>
          </div>
        </div>
        <div id="allmap" class="map_contain" /> -->
        <div class="save_button">
          <el-button type="primary" @click="saveMethod">
            保存
          </el-button>
        </div>
      </div>
      <!-- 添加地块 -->
      <addFolderCompoment
        :isshow="isShowAddFolderWindow"
        @closeWindow="closeAddFolderWindow"
        @confirmWindow="confirmAddFolderWindow"
      />
      <!-- 添加区域 -->
      <addAreaCompoment
        :isshow="isShowAddAreaWindow"
        @closeWindow="closeAddAreaWindow"
        @confirmWindow="confirmAddAreaWindow"
      />
      <!-- 修改地块文件夹名称 -->
      <eidteFolderCompoment
        :isshow="isShowEditeFolderWindow"
        :current-template-name="editeData"
        @closeWindow="closeEidteFolderWindow"
        @confirmWindow="confirmEidteFolderWindow"
      />
      <!-- 修改区域名称 -->
      <editeAreaCompoment
        :isshow="isShowEditeAreaWindow"
        :current-template-name="editeData"
        @closeWindow="closeEditeAreaWindow"
        @confirmWindow="confirmEditeAreaWindow"
      />
      <!-- 添加空区域模版 -->
      <addTempAreaTemplate
        :isshow="isShowAddTempAreaTeleplateWindow"
        @closeWindow="closeAddTempTeleplateWindow"
        @confirmWindow="confirmAddTempTeleplateWindow"
      />
      <!-- 修改区域模版名称 -->
      <changeAreaTemplateName
        :isshow="isShowChangeAreaNameTeleplateWindow"
        :current-template="currentSelectTemplate"
        @closeWindow="closeChangeAreaNameTeleplateWindowMenthod"
        @confirmWindow="confirmChangeAreaNameTeleplateWindowMenthod"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Axios from '@/lib/axios';
import API from '@/lib/apiList';
import addFolderCompoment from './componments/addFolderCompoment';
import addAreaCompoment from './componments/addAreaCompoment';
import editeAreaCompoment from './componments/editeAreaCompoment';
import eidteFolderCompoment from './componments/eidteFolderCompoment';
import addTempAreaTemplate from './componments/addTempAreaTemplate';
import changeAreaTemplateName from './componments/changeAreaTemplateName';

export default {
  components: {
    addFolderCompoment,
    addAreaCompoment,
    editeAreaCompoment,
    eidteFolderCompoment,
    addTempAreaTemplate,
    changeAreaTemplateName
  },
  data() {
    return {
      templateVlaue: '', // 当前模板
      currentSelectTemplate: null, // 当前选中的模板
      isShowAddTempAreaTeleplateWindow: false,
      isShowChangeAreaNameTeleplateWindow: false,
      templateArray: [],
      searchKeyword: '', // 位置关键字
      isShowAddAreaWindow: false, // 是否显示添加区域弹窗
      isShowAddFolderWindow: false, // 是否显示添加文件夹弹窗
      isShowEditeAreaWindow: false, // 是否显示编辑区域弹窗
      isShowEditeFolderWindow: false, // 是否显示编辑文件夹弹窗
      editeData: null, // 编辑时选中的data
      currentAreaData: null, // 当前选中的data
      searchKey: '', // 搜索关键字
      mapManager: null, // 地图实例
      polyEditor: null, // 地图编辑实例
      currentEidtePolygon: null, // 当前选中的要编辑的路径实例
      currentAreaName: '', // 当前选中的地块名称
      currentSelectData: null, // 当前选中的data
      areaArray: [] // 左侧区域列表
    };
  },
  watch: {
    /** 监听当前选中的区域数据 */
    // currentAreaData(val) {
    //   if (val) {
    //     const coord = val.coord || '[]';
    //     this.reDrawMapPath(JSON.parse(val.coord));
    //   }
    // },
    currentSelectTemplate(val) {
      if (val) {
        this.currentAreaData = null;
        this.getAndDealTreeData();
      }
    }
  },
  mounted() {
    this.getAllTemplateRequest();
    this.getAndDealTreeData();
    // this.initMapMethod().then(() => {
    // });
  },

  methods: {
    inputChangeAnother() {
      this.searchMenthod();
    },
    /**
     * 高德地图关键字搜索
     * */
    // searchMenthod() {
    //   const that = this;
    //   const keywords = this.searchKeyword;
    //   AMap.plugin('AMap.PlaceSearch', () => {
    //     const autoOptions = {
    //       city: '全国'
    //     };
    //     const placeSearch = new AMap.PlaceSearch(autoOptions);
    //     placeSearch.search(keywords, (status, result) => {
    //       that.setMapCenterMenthod(result);
    //     });
    //   });
    // },

    /**
     * 设置地图中心点
     * */
    // setMapCenterMenthod(result) {
    //   if (result instanceof Object) {
    //     if (result.poiList.pois.length > 0) {
    //       const { lng } = result.poiList.pois[0].location;
    //       const { lat } = result.poiList.pois[0].location;
    //       this.mapManager.setCenter([lng, lat]);
    //     }
    //   }
    // },

    /** 请求左侧列表以及处理树状结构的数据 */
    getAndDealTreeData() {
      this.getAreaInfoRequest().then((res) => {
        // 请求成功后调用这个初始化tree方法
        this.initAreaTreeMethod(res);
      });
    },
    /** 初始化地图 */
    // initMapMethod() {
    //   const that = this;
    //   return new Promise((resolve, reject) => {
    //     const map = new AMap.Map('allmap', {
    //       zoom: 15,
    //       resizeEnable: true
    //     });
    //     this.mapManager = map;
    //     AMap.plugin('AMap.PolygonEditor', () => {
    //       that.polyEditor = new AMap.PolygonEditor(map);
    //       that.polyEditor.on('add', (data) => {
    //         const polygon = data.target;
    //         that.polyEditor.addAdsorbPolygons(polygon);
    //         polygon.on('dblclick', () => {
    //           that.polyEditor.setTarget(polygon);
    //           that.polyEditor.open();
    //           that.currentEidtePolygon = polygon;
    //         });
    //       });
    //       resolve();
    //     });
    //   });
    // },

    /** 初始化区域tree数据 */
    initAreaTreeMethod(originalDataArray) {
      for (let index = 0; index < originalDataArray.length; index++) {
        const element = originalDataArray[index];
        element.isSelected = true;
        element.children = element.children1 || [];
        element.isFolder = true;
        element.areaId = 0;
        element.level = 0;
        for (let index = 0; index < element.children.length; index++) {
          const secondElement = element.children[index];
          secondElement.isSelected = true;
          secondElement.isFolder = true;
          secondElement.children = secondElement.children1 || [];
          for (let index = 0; index < secondElement.children.length; index++) {
            const thirdElement = secondElement.children[index];
            thirdElement.isFolder = thirdElement.fileType == 1;
            thirdElement.children = thirdElement.children1 || [];
            thirdElement.isSelected = false;
            if (thirdElement.isFolder) {
              thirdElement.isSelected = true;
            }
            if (this.currentAreaData) {
              if (!thirdElement.isFolder && this.currentAreaData.areaId == thirdElement.areaId) {
                thirdElement.isSelected = true;
                this.currentAreaData = thirdElement;
                this.currentAreaName = thirdElement.nodeName;
              }
            } else if (!thirdElement.isFolder && index == 0) {
              thirdElement.isSelected = true;
              this.currentAreaData = thirdElement;
              this.currentAreaName = thirdElement.nodeName;
            }

            for (let index = 0; index < thirdElement.children.length; index++) {
              const fourthElement = thirdElement.children[index];
              fourthElement.isFolder = fourthElement.fileType == 1;
              fourthElement.children = [];
              fourthElement.isSelected = false;
              if (this.currentAreaData) {
                if (this.currentAreaData.areaId == fourthElement.areaId) {
                  fourthElement.isSelected = true;
                  this.currentAreaData = fourthElement;
                  this.currentAreaName = fourthElement.nodeName;
                }
              } else if (index == 0) {
                fourthElement.isSelected = true;
                this.currentAreaData = fourthElement;
                this.currentAreaName = fourthElement.nodeName;
              }
            }
          }
        }
      }
      this.areaArray = originalDataArray;
    },

    /** 初始化已经绘制的区域 */
    initPathMethod(coord) {
      if (!coord) {
        return;
      }
      for (let index = 0; index < coord.length; index++) {
        const element = coord[index];
        const polygon = new AMap.Polygon({
          path: element
        });
        this.mapManager.add(polygon);
        this.polyEditor.addAdsorbPolygons(polygon);
        polygon.on('dblclick', () => {
          this.polyEditor.setTarget(polygon);
          this.polyEditor.open();
          this.currentEidtePolygon = polygon;
        });
      }
      this.mapManager.setFitView();
    },

    /** 获取树形节点小图标 */
    getTreeIconImagePath(data) {
      if (data.isFolder) {
        if (data.isSelected) {
          return require('../../../../assets/img/area_folderSpend.png');
        }
        return require('../../../../assets/img/area_folder.png');
      }
      return require('../../../../assets/img/area_quyuguanli.png');
    },

    /** 获取树形文本数据 */
    getTreeText(data) {
      if (data.isFolder) {
        return data.nodeName;
      }
      return data.nodeName;
    },

    /** 区域位置是否被选中 */
    areaIsSelected(data) {
      if (!data.isFolder) {
        if (data.isSelected) {
          return true;
        }
      }
      return false;
    },

    /** 左侧添加区域位置按钮是否可用 */
    addAreaLoacationIsEnable() {
      if (!this.currentSelectData) {
        return false;
      }
      const data = this.currentSelectData;
      const tmpDataArray = data.children;
      let nextIsFolder = false; // 下一级是否是区域位置
      for (let index = 0; index < tmpDataArray.length; index++) {
        const element = tmpDataArray[index];
        if (element.isFolder) {
          nextIsFolder = true;
        }
      }
      if (data.level == 1) {
        // if (!nextIsFolder || tmpDataArray.length == 0) {
        return true;
        // }
      }
      if (data.level == 2 && data.isFolder) {
        return true;
      }
      return false;
    },

    /** 是否可以添加文件夹 */
    addFolderIsCanEnable() {
      if (!this.currentSelectData) {
        return false;
      }
      const data = this.currentSelectData;
      const tmpDataArray = data.children;
      let nextIsFolder = false; // 下一级是否是区域位置
      for (let index = 0; index < tmpDataArray.length; index++) {
        const element = tmpDataArray[index];
        if (element.isFolder) {
          nextIsFolder = true;
        }
      }
      if (data.level == 1) {
        // if (nextIsFolder || tmpDataArray.length == 0) {
        return true;
        // }
      }
      if (data.level == 0) {
        return true;
      }
      return false;
    },

    /** 是否可以保存 */
    isEnableSave() {
      if (!this.currentAreaData) {
        return false;
      }
      if (!this.currentAreaData.isFolder) {
        return true;
      }
      return false;
    },

    /** 搜索左侧节点 */
    inputChanged() {
      this.$refs.tree.filter(this.searchKey);
    },

    /** 筛选节点 */
    filterNode(value, data) {
      if (!value) return true;
      return data.nodeName.indexOf(value) !== -1;
    },

    /** 点击节点 */
    nodeClicked(data) {
      this.currentSelectData = data;
      if (!data.isFolder) {
        // 点击的是区域位置
        for (let index = 0; index < this.areaArray.length; index++) {
          /** 第一级 */
          const elementFirst = this.areaArray[index];
          for (let index = 0; index < elementFirst.children.length; index++) {
            /** 第二级 */
            const elementSecond = elementFirst.children[index];
            for (let index = 0; index < elementSecond.children.length; index++) {
              /** 第三级 */
              const elementThird = elementSecond.children[index];
              if (!elementThird.isFolder) {
                if (elementThird.areaId == data.areaId) {
                  elementThird.isSelected = true;
                  this.currentAreaName = elementThird.nodeName;
                  this.currentAreaData = data;
                } else {
                  elementThird.isSelected = false;
                }
              }

              for (let index = 0; index < elementThird.children.length; index++) {
                /** 第四级 */
                const elementFour = elementThird.children[index];
                if (elementFour.areaId == data.areaId) {
                  elementFour.isSelected = true;
                  this.currentAreaName = elementFour.nodeName;
                  this.currentAreaData = data;
                } else {
                  elementFour.isSelected = false;
                }
              }
            }
          }
        }
      } else {
        // 点击的地块
        data.isSelected = !data.isSelected;
      }
    },

    /** 重新绘制地图路径 */
    reDrawMapPath(coord) {
      this.polyEditor.close();
      this.polyEditor.setTarget();
      this.mapManager.clearMap();
      this.initPathMethod(coord);
    },

    /** 处理要上传的数据 */
    dealWithRequestData() {
      const tmpArray = [];
      const tmp = this.mapManager.getAllOverlays('polygon');
      for (let index = 0; index < tmp.length; index++) {
        const element = tmp[index];
        const polygonPath = `${element}`;
        tmpArray.push(polygonPath.split(';'));
      }
      const totalArray = [];
      for (let index = 0; index < tmpArray.length; index++) {
        const element = tmpArray[index];
        const sonArray = [];
        for (let index = 0; index < element.length; index++) {
          let sonElement = element[index];
          sonElement = sonElement.split(',');
          for (let index = 0; index < sonElement.length; index++) {
            const tmp = sonElement[index];
            sonElement[index] = parseFloat(tmp);
          }
          sonArray.push(sonElement);
        }
        totalArray.push(sonArray);
      }
      return totalArray;
    },

    /** 处理修改地块名称和区域名称之后的 */
    dealEditeNameData(areaId, nodeName) {
      for (let index = 0; index < this.areaArray.length; index++) {
        const oneElement = this.areaArray[index];
        for (let index = 0; index < oneElement.children.length; index++) {
          const secondElement = oneElement.children[index];
          if (secondElement.areaId == areaId) {
            secondElement.nodeName = nodeName;
          }
          for (let index = 0; index < secondElement.children.length; index++) {
            const thirdElement = secondElement.children[index];
            if (thirdElement.areaId == areaId) {
              thirdElement.nodeName = nodeName;
            }
            for (let index = 0; index < thirdElement.children.length; index++) {
              const fourthElement = thirdElement.children[index];
              if (fourthElement.areaId == areaId) {
                fourthElement.nodeName = nodeName;
              }
            }
          }
        }
      }
    },

    /** -------------------------------------------按钮事件------------------------------------------- */
    addAreaMethod() {
      if (!this.addAreaLoacationIsEnable()) {
        this.$message.error('清先选择地块!');
        return;
      }
      this.isShowAddAreaWindow = true;
    },

    addFolderMethod() {
      if (!this.addFolderIsCanEnable()) {
        this.$message.error('请先选择项目或父级地块!');
        return;
      }
      this.isShowAddFolderWindow = true;
    },

    /** 编辑地块，编辑区域 */
    editeMethod(data) {
      this.editeData = data;
      if (data.isFolder) {
        this.isShowEditeFolderWindow = true;
      } else {
        this.isShowEditeAreaWindow = true;
      }
    },

    /** 删除地块和区域 */
    deleteMethod(data) {
      this.$confirm(`确定要删除 "${data.nodeName}" 吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.deleteAreaRequest(data.areaId).then(() => {
            if (this.currentSelectData.areaId == data.areaId) {
              this.currentSelectData = null;
              this.currentAreaName = '';
            }
            this.getAndDealTreeData();
          });
        })
        .catch(() => {});
    },

    // createPolygon() {
    //   if (this.currentAreaData) {
    //     this.polyEditor.close();
    //     this.polyEditor.setTarget();
    //     this.polyEditor.open();
    //   } else {
    //     this.$message.error('请先选择区域!');
    //   }
    // },

    // clearMapMethod() {
    //   this.$confirm(`确定要清空绘制区域吗?`, '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   })
    //     .then(() => {
    //       this.clearMapAreaRequest();
    //     })
    //     .catch(() => {});
    // },

    /** 清除选中的 Polygon */
    // clearSinglePolyonMethod() {
    //   this.polyEditor.close();
    //   this.polyEditor.setTarget();
    //   this.mapManager.remove(this.currentEidtePolygon);
    // },

    saveMethod() {
      if (!this.isEnableSave()) {
        this.$message.error('请先选择区域');
        return;
      }
      this.saveMapAreaLocation();
    },

    closeAddFolderWindow() {
      this.isShowAddFolderWindow = false;
    },

    confirmAddFolderWindow(e) {
      this.addFolderOrArea(e.nodeName, true);
      this.isShowAddFolderWindow = false;
    },

    closeAddAreaWindow() {
      this.isShowAddAreaWindow = false;
    },

    confirmAddAreaWindow(e) {
      this.addFolderOrArea(e.nodeName, false);
      this.isShowAddAreaWindow = false;
    },

    closeEidteFolderWindow() {
      this.isShowEditeFolderWindow = false;
    },

    confirmEidteFolderWindow(e) {
      this.editeAreaName(e.nodeName, e.areaId);
      this.isShowEditeFolderWindow = false;
    },

    closeEditeAreaWindow() {
      this.isShowEditeAreaWindow = false;
    },

    confirmEditeAreaWindow(e) {
      this.editeAreaName(e.nodeName, e.areaId);
      this.isShowEditeAreaWindow = false;
    },

    /** 模板切换 */
    templateVlaueChanged() {
      this.templateArray.forEach((element) => {
        if (element.modelId === this.templateVlaue) {
          this.currentSelectTemplate = element;
        }
      });
    },

    /** 修改模板名称 */
    changeTemeplateMethod() {
      this.isShowChangeAreaNameTeleplateWindow = true;
    },

    /** 删除模板 */
    deleteTemeplateMethod() {
      this.$confirm(`确定要删除 "${this.currentSelectTemplate.modelName}" 吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.deleteTemplateRequestMethod();
        })
        .catch(() => {});
    },

    /** 创建空模板 */
    createEmptyTemplete() {
      this.isShowAddTempAreaTeleplateWindow = true;
    },

    /** 设为当前模板 */
    updateQualityDataRequest() {
      this.setDefauleTemelateMethod();
    },

    closeAddTempTeleplateWindow() {
      this.isShowAddTempAreaTeleplateWindow = false;
    },

    confirmAddTempTeleplateWindow() {
      this.isShowAddTempAreaTeleplateWindow = false;
      this.getAllTemplateRequest();
    },

    closeChangeAreaNameTeleplateWindowMenthod() {
      this.isShowChangeAreaNameTeleplateWindow = false;
    },

    confirmChangeAreaNameTeleplateWindowMenthod() {
      this.isShowChangeAreaNameTeleplateWindow = false;
      this.getAllTemplateRequest();
    },

    /** ----------------------------------------网络请求相关----------------------------------------- */
    /** 请求左侧区域列表 */
    getAreaInfoRequest() {
      return new Promise((resolve, reject) => {
        Axios.requestWWWForm({
          url: '/unicom/qclandarea/select',
          data: {
            projectId: this.$cookies.get('PROJECT_ID'),
            modelId: this.currentSelectTemplate.modelId
          }
        })
          .then((res) => {
            if (res.data.code === '1000') {
              resolve(res.data.result);
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
      });
    },

    /** 请求区域图形 */
    getAreaPolygonRequest(areaId) {
      return new Promise((resolve, reject) => {
        Axios.requestWWWForm({
          url: '/unicom/project/cascade',
          data: {
            projectId: this.$cookies.get('PROJECT_ID'),
            roleId: '6d7513c8b3fd4a50a439f020092d8256'
          }
        })
          .then((res) => {
            if (res.data.code === '1000') {
              resolve(res.data.result);
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
      });
    },

    /** 删除区域 */
    deleteAreaRequest(areaId) {
      return new Promise((resolve, reject) => {
        Axios.requestWWWForm({
          url: '/unicom/qclandarea/deleteByPrimaryKey',
          data: {
            projectId: this.$cookies.get('PROJECT_ID'),
            areaId
          }
        })
          .then((res) => {
            if (res.data.code === '1000') {
              resolve(res.data.result);
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
      });
    },

    /** 添加文件夹和区域 */
    addFolderOrArea(areaName, isFolder) {
      Axios.requestWWWForm({
        url: '/unicom/qclandarea/insertByPrimaryKey',
        data: {
          projectId: this.$cookies.get('PROJECT_ID'),
          creator: this.$cookies.get('b-updateUser').realName,
          nodeName: areaName,
          parentId: this.currentSelectData.areaId == 0 ? null : this.currentSelectData.areaId,
          level: parseInt(this.currentSelectData.level) + 1,
          fileType: isFolder ? 1 : 2,
          modelId: this.currentSelectTemplate.modelId
        }
      })
        .then((res) => {
          if (res.data.code === '1000') {
            this.$message.success('添加成功');
            this.getAndDealTreeData();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /** 保存区域地图上的位置 */
    saveMapAreaLocation() {
      // const totalArray = this.dealWithRequestData();
      // if (totalArray.length <= 0) {
      //   this.$message.error('请先绘制区域！');
      //   return;
      // }
      Axios.requestWWWForm({
        url: '/unicom/qclandarea/updateByPrimaryKey',
        data: {
          projectId: this.$cookies.get('PROJECT_ID'),
          areaId: this.currentAreaData.areaId
          // coord: JSON.stringify(totalArray)
        }
      })
        .then((res) => {
          if (res.data.code === '1000') {
            this.$message.success('保存成功');
            this.getAndDealTreeData();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /** 清空绘制区域 */
    // clearMapAreaRequest() {
    //   Axios.requestWWWForm({
    //     url: '/unicom/qclandarea/updateByPrimaryKey',
    //     data: {
    //       projectId: this.$cookies.get('PROJECT_ID'),
    //       areaId: this.currentSelectData.areaId,
    //       coord: JSON.stringify([])
    //     }
    //   })
    //     .then((res) => {
    //       if (res.data.code === '1000') {
    //         this.$message.success('清空绘制区域成功');
    //         this.polyEditor.close();
    //         this.polyEditor.setTarget();
    //         this.mapManager.clearMap();
    //         this.getAndDealTreeData();
    //       } else {
    //         this.$message.error(res.data.msg);
    //       }
    //     })
    //     .catch((err) => {
    //       this.$message.error(err);
    //     });
    // },

    /** 修改地块名称，修改区域名称 */
    editeAreaName(nodeName, areaId) {
      Axios.requestWWWForm({
        url: '/unicom/qclandarea/updateByPrimaryKey',
        data: {
          projectId: this.$cookies.get('PROJECT_ID'),
          areaId,
          nodeName
        }
      })
        .then((res) => {
          if (res.data.code === '1000') {
            this.$message.success('修改成功');
            this.getAndDealTreeData();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /** 获取所有的模版 */
    getAllTemplateRequest() {
      const that = this;
      Axios.requestWWWForm({
        url: '/unicom/qclandarea/queryAreaModelList',
        data: {
          projectId: this.$cookies.get('PROJECT_ID')
        }
      })
        .then((res) => {
          if (res.data.code === '1000') {
            this.templateArray = res.data.result || [];
            if (this.templateArray.length > 0) {
              if (!this.currentSelectTemplate) {
                /** 未选中模版, 选择当前模版 */
                this.currentSelectTemplate = this.templateArray[0];
                this.templateVlaue = this.templateArray[0].modelId;
                for (let index = 0; index < this.templateArray.length; index++) {
                  const element = this.templateArray[index];
                  if (element.isModel == 1) {
                    this.currentSelectTemplate = element;
                    this.templateVlaue = element.modelId;
                  }
                }
              } else {
                /** 如果已经选中了模版 */
                for (let index = 0; index < this.templateArray.length; index++) {
                  const element = this.templateArray[index];
                  if (element.modelId == this.currentSelectTemplate.modelId) {
                    this.currentSelectTemplate = element;
                    this.templateVlaue = element.modelId;
                  }
                }
              }
            }
          } else {
            that.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          that.$message.error(err);
        });
    },

    /** 设为默认模板*/
    setDefauleTemelateMethod() {
      Axios.requestWWWForm({
        url: '/unicom/qclandarea/setDefaultModel',
        data: {
          projectId: this.$cookies.get('PROJECT_ID'),
          modelId: this.currentSelectTemplate.modelId,
          isModel: 1
        }
      })
        .then((res) => {
          if (res.data.code === '1000') {
            this.$message.success('设置成功');
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /** 删除模板*/
    deleteTemplateRequestMethod() {
      Axios.requestWWWForm({
        url: '/unicom/qclandarea/deleteAreaModel',
        data: {
          projectId: this.$cookies.get('PROJECT_ID'),
          modelId: this.currentSelectTemplate.modelId
        }
      })
        .then((res) => {
          if (res.data.code === '1000') {
            this.$message.success('删除成功');
            this.currentSelectTemplate = null;
            this.templateVlaue = '';
            this.getAllTemplateRequest();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    }
  }
};
</script>

<style scoped>
::v-deep .companyTree .el-tree-node__content {
  height: 30px;
  line-height: 30px;
}

.wrapper {
  overflow: hidden;
  background: white;
  display: flex;
  flex-direction: row;
  min-height: 620px;
  border-color: rgb(229, 235, 238);
  border-width: 1px;
  border-style: solid;
}

.total_left_content {
  display: flex;
  flex-direction: column;
  width: 30%;
}

.left_bottom_contain {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 15px;
}

.total_right_content {
  display: flex;
  flex-direction: column;
  width: 70%;
  padding-right: 20px;
}

.top_space_between {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 45px;
  padding-left: 20px;
  padding-right: 20px;
  border-bottom-color: rgb(229, 235, 238);
  border-bottom-width: 1px;
  border-bottom-style: solid;
}

.left_border {
  border-left-color: rgb(229, 235, 238);
  border-left-width: 1px;
  border-left-style: solid;
}

.flex_row_center {
  display: flex;
  align-items: center;
  flex-direction: row;
}

.map_contain {
  width: 100%;
  height: 100%;
}

.save_button {
  display: flex;
  align-items: center;
  padding-left: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-top-color: rgb(229, 235, 238);
  border-top-width: 1px;
  border-top-style: solid;
}

.margin_bottom_10 {
  margin-bottom: 10px;
}

.tree_leftIcon {
  width: 17px;
  height: 17px;
  margin-right: 5px;
}

.display_flex_center_row {
  display: flex;
  align-items: center;
  overflow: hidden;
}

.space_between {
  justify-content: space-between;
  width: 100%;
}

.treeTitle_normal {
  font-weight: 400;
  font-size: 14px;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: calc(100% - 20px);
}

.treeTitle_selected {
  font-weight: 400;
  font-size: 14px;
  color: rgba(24, 144, 255, 1);
}

.fontsize_12_color {
  font-size: 12px;
  color: #999999;
  margin-left: 10px;
}

.flex_column_top {
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  background: #ffffff;
}

.bottom_boder_style {
  border-top-color: rgb(229, 235, 238);
  border-top-width: 1px;
  border-top-style: solid;
}

.paddingleft_20_right_20 {
  padding-left: 20px;
  padding-right: 20px;
}

.font_16_color_37474f {
  font-size: 16px;
  color: #37474f;
  font-weight: 450;
}

.quality_logo {
  width: 14px;
  height: 14px;
  margin-left: 20px;
  margin-right: 5px;
}

.font_14_999 {
  font-size: 14px;
  color: #999999;
}

.div_spaceBetween {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}

::v-deep .currentInput .el-input__inner {
  height: 34px !important;
  line-height: 34px !important;
}
</style>
